import { GET_CLIENT_CONFIG, SET_CLIENT_CONFIG,CLEAR_CLIENT_CONFIG } from "./types";
import api from "../utils/api";

export const getClientConfig =
  () =>
  async (dispatch) => {
    try {
      dispatch({
        type: GET_CLIENT_CONFIG,
      });

      const res = await api.get("/client-config");
      dispatch({
        type: SET_CLIENT_CONFIG,
        payload: res.data,
      });
    }
     catch (error) {
      console.error(error);
    }
  };

export const clearClientConfig = () => (dispatch) => {
  dispatch({
    type: CLEAR_CLIENT_CONFIG,
  });
};
